import React from 'react';

const Spinner = () => {
  return (
    <div>
      <img
        src="https://ershemug.sirv.com/evabills/loader.gif"
        alt="loader"
        width={'100px'}
        className="mx-auto"
      />
    </div>
  );
};

export default Spinner;
